import { UniqueIdentifier } from '@/api/types/base'
import { DriveDocument } from '@/api/types/drive'
import { RequestInfo } from './root'

export type DriveState = {
  ownerDrives: Array<DriveDocument> | null
  shareeDrives: Array<DriveDocument> | null
  selectedDriveUuid: UniqueIdentifier | null
  drivesRequests: DrivesRequests
}

export type SetupDriveDetails = {
  name: string
  letter: string
  owner: string
  uuid: string
}

// not strictly used by store, but by Browser & Connection Modal
export type ConnectionDetails = {
  // common
  protocol: string
  port: number
  accessKeyId: string
  secretAccessKey: string

  // Cyberduck
  server: string

  // FileZilla Pro
  host: string
  defaultRemoteDirectory: string
}

export type DriveData = {
  name?: string
  custom_drive_letter?: string
}

// Requests

export type DriveRequests = {
  updateDrive: RequestInfo
}

export type DriveRequestName = 'updateDrive'

export type RequestStatus = 'none' | 'pending' | 'successful' | 'failed'

export class DriveRequestUpdate {
  name: DriveRequestName
  info: RequestInfo
  uuid: string
  constructor(uuid: string, name: DriveRequestName, status: RequestStatus, error?: string) {
    this.uuid = uuid
    this.name = name
    this.info = new RequestInfo({ status, error })
  }
}

export type DrivesRequests = {
  [key: string]: DriveRequests
}
